module.exports = __webpack_public_path__ + "static/media/IMG_1521.8a14e417.jpg";